import * as types from '@types'
import * as services from '@services/personalInfo'

export default {
  state: {
    personal: {},
    foreign: {},
    handicap: {},
    options: {},
    customFields: {}
  },

  getters: {
    [types.EMPLOYEE_PERSONAL_INFO]: state => ({ ...state.personal })
  },

  mutations: {
    [types.EMPLOYEE_UPDATE_PERSONAL]: (state, data) => {
      state.personal = { ...state.personal, ...data }
    },
    [types.EMPLOYEE_UPDATE_FOREIGN]: (state, data) => {
      state.foreign = { ...state.foreign, ...data }
    },
    [types.EMPLOYEE_UPDATE_HANDICAP]: (state, data) => {
      state.handicap = { ...state.handicap, ...data }
    },
    [types.EMPLOYEE_PERSONAL_OPTIONS]: (state, options) => {
      state.options = { ...options }
    },
    [types.EMPLOYEE_PERSONAL_CUSTOM_FIELDS]: (state, data) => {
      state.customFields = { ...data }

      const reduceValues = (acc, [ id, field ]) => ({ [id]: field.value, ...acc })

      const personalValues = Object.entries(data.personal.schema).reduce(reduceValues, {})
      const disabilityValues = Object.entries(data.handicap.schema).reduce(reduceValues, {})
      const foreignValues = Object.entries(data.foreign.schema).reduce(reduceValues, {})

      state.personal = { ...state.personal, ...personalValues }
      state.handicap = { ...state.handicap, ...disabilityValues }
      state.foreign = { ...state.foreign, ...foreignValues }
    }
  },

  actions: {
    [types.EMPLOYEE_PERSONAL_INFO]: async ({ commit, getters }) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err, data ] = await services.getPersonal({ employeeId, companyId })

      if (!err) commit(types.EMPLOYEE_UPDATE_PERSONAL, data)

      return [ err, data ]
    },

    [types.EMPLOYEE_GET_HANDICAP]: async ({ commit, getters }) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err, data ] = await services.getHandicap({ employeeId, companyId })

      if (!err) commit(types.EMPLOYEE_UPDATE_HANDICAP, data)

      return [ err, data ]
    },

    [types.EMPLOYEE_GET_FOREIGN]: async ({ commit, getters }) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err, data ] = await services.getForeign({ employeeId, companyId })

      if (!err) commit(types.EMPLOYEE_UPDATE_FOREIGN, data)

      return [ err, data ]
    },

    [types.EMPLOYEE_PERSONAL_CUSTOM_FIELDS]: async ({ commit, getters }) => {
      const [ err, data ] = await services.getCustomFields(getters)

      if (!err) commit(types.EMPLOYEE_PERSONAL_CUSTOM_FIELDS, data)

      return [ err, data ]
    },

    [types.EMPLOYEE_PERSONAL_OPTIONS]: async ({ state, commit }) => {
      if (Object.keys(state.options).length) return

      const [ err, options ] = await services.getOptions()

      if (!err) commit(types.EMPLOYEE_PERSONAL_OPTIONS, options)

      return [ err, options ]
    },

    [types.EMPLOYEE_UPDATE_PERSONAL]: async ({ state, getters, commit }, data) => {
      const { schema } = state.customFields?.personal || {}
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId, schema }

      const [ err, personal ] = await services.updatePersonal(data, params)

      if (!err) commit(types.EMPLOYEE_UPDATE_PERSONAL, personal)

      return [ err, personal ]
    },

    [types.EMPLOYEE_UPDATE_EMPLOYEE]: async ({ getters }, data) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err ] = await services.updateEmployee(data, { companyId, employeeId })

      return [ err ]
    },

    [types.EMPLOYEE_UPDATE_NATIONALITIES]: async ({ getters }, data) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid

      const [ err, nationalities ] = await services.updateNationalities(
        data,
        { companyId, employeeId }
      )

      return [ err, nationalities ]
    },

    [types.EMPLOYEE_UPDATE_FOREIGN]: async ({ state, getters, commit }, data) => {
      const { schema } = state.customFields?.foreign || {}
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId, schema }

      const [ err, foreign ] = await services.updateForeign(data, params)

      if (!err) commit(types.EMPLOYEE_UPDATE_FOREIGN, foreign)

      return [ err, foreign ]
    },

    [types.EMPLOYEE_UPDATE_HANDICAP]: async ({ state, commit, getters }, data) => {
      const { schema } = state.customFields?.handicap || {}
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId, schema }

      const [ err, handicap ] = await services.updateHandicap(data, params)

      if (!err) commit(types.EMPLOYEE_UPDATE_HANDICAP, handicap)

      return [ err, handicap ]
    },

    [types.EMPLOYEE_DELETE_HANDICAP]: async ({ getters }, data) => {
      const employeeId = getters.getEmployeeUuid
      const companyId = getters.getCompanyUuid
      const params = { employeeId, companyId }

      const [ err ] = await services.deleteHandicap(params)

      return [ err, data ]
    },
  }
}
